module.exports = __webpack_public_path__ + "04_medium_gold.e4d5025f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_medium_gold.png
// module id = OVtj
// module chunks = 0